<!-- @veltra/icons generated sha256:f1c7a278d1335bcc gen:8 source:src/svg/normal/form-switch.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormSwitch' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="8"
      x="1"
      y="4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="4"
    />
    <circle cx="11" cy="8" r="2.2" fill="currentColor" />
  </svg>
</template>
